<template>
  <div
    class="select-service"
    :class="{ 'has-error': bookingServicePickerError }"
  >
    <n-popover
      v-model:show="showDropdown"
      trigger="click"
      :show-arrow="false"
      :placement="isDesktop.value ? 'bottom-start' : 'bottom-start'"
      :style="{
        width: width,
        marginLeft: marginLeft,
      }"
      :overlap="isDesktop.value ? false : overlap"
      :to="popoverTarget"
      :scrollable="true"
    >
      <template #trigger>
        <button
          class="dropdown-btn"
          :class="{ active: showDropdown }"
          aria-controls="dropdownContent"
        >
          {{ selectedLabel || bookingStore.serviceFamily || placeholderText }}
          <i class="n-base-icon n-base-suffix__arrow">
            <svg
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.14645 5.64645C3.34171 5.45118 3.65829 5.45118 3.85355 5.64645L8 9.79289L12.1464 5.64645C12.3417 5.45118 12.6583 5.45118 12.8536 5.64645C13.0488 5.84171 13.0488 6.15829 12.8536 6.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645Z"
                fill="currentColor"
              ></path>
            </svg>
          </i>
        </button>
      </template>

      <div
        id="dropdownContent"
        ref="dropdownContent"
        class="custom-dropdown"
        :class="{ 'mobile-dropdown': !isDesktop }"
        :aria-expanded="showDropdown"
      >
        <!-- Loop over groups -->
        <button
          v-if="!isDesktop"
          class="close-btn"
          @click="showDropdown = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
          >
            <path
              d="M9.2535 0.742327C9.09736 0.587118 8.88615 0.5 8.666 0.5C8.44584 0.5 8.23463 0.587118 8.0785 0.742327L5.08683 3.69233L2.13683 0.742327C1.9807 0.587118 1.76949 0.5 1.54933 0.5C1.32918 0.5 1.11797 0.587118 0.961831 0.742327C0.883724 0.819796 0.821728 0.911964 0.779421 1.01351C0.737114 1.11506 0.715332 1.22398 0.715332 1.33399C0.715332 1.444 0.737114 1.55292 0.779421 1.65447C0.821728 1.75602 0.883724 1.84819 0.961831 1.92566L4.49516 5.45899C4.57263 5.5371 4.6648 5.5991 4.76635 5.6414C4.8679 5.68371 4.97682 5.70549 5.08683 5.70549C5.19684 5.70549 5.30576 5.68371 5.40731 5.6414C5.50886 5.5991 5.60103 5.5371 5.6785 5.45899L9.2535 1.92566C9.3316 1.84819 9.3936 1.75602 9.43591 1.65447C9.47821 1.55292 9.5 1.444 9.5 1.33399C9.5 1.22398 9.47821 1.11506 9.43591 1.01351C9.3936 0.911964 9.3316 0.819796 9.2535 0.742327Z"
              fill="black"
            />
            <path
              d="M9.2535 9.46275C9.09736 9.61796 8.88615 9.70508 8.666 9.70508C8.44584 9.70508 8.23463 9.61796 8.0785 9.46275L5.08683 6.51275L2.13683 9.46275C1.9807 9.61796 1.76949 9.70508 1.54933 9.70508C1.32918 9.70508 1.11797 9.61796 0.961831 9.46275C0.883724 9.38528 0.821728 9.29311 0.779421 9.19157C0.737114 9.09002 0.715332 8.98109 0.715332 8.87108C0.715332 8.76107 0.737114 8.65215 0.779421 8.5506C0.821728 8.44905 0.883724 8.35689 0.961831 8.27942L4.49516 4.74608C4.57263 4.66798 4.6648 4.60598 4.76635 4.56368C4.8679 4.52137 4.97682 4.49959 5.08683 4.49959C5.19684 4.49959 5.30576 4.52137 5.40731 4.56368C5.50886 4.60598 5.60103 4.66798 5.6785 4.74608L9.2535 8.27942C9.3316 8.35689 9.3936 8.44905 9.43591 8.5506C9.47821 8.65215 9.5 8.76107 9.5 8.87108C9.5 8.98109 9.47821 9.09002 9.43591 9.19157C9.3936 9.29311 9.3316 9.38528 9.2535 9.46275Z"
              fill="black"
            />
          </svg>
          <span class="sr-only">Close</span>
        </button>
        <div class="custom-dropdown-inner">
          <span
            v-if="!isDesktop"
            class="h2"
            >{{ translationsStore.t("booking_service_picker_title") }}</span
          >
          <div
            v-for="group in groups"
            :key="group.key"
            class="dropdown-group"
          >
            <div class="dropdown-group-header">{{ group.label }}</div>

            <n-list :show-divider="false">
              <n-list-item
                v-for="item in group.children"
                :key="item.value"
                class="dropdown-option"
                :style="{ padding: '0' }"
              >
                <button
                  class="option-content"
                  @click="selectOption(item)"
                >
                  <div
                    v-if="item.pictogram"
                    class="icon-wrapper"
                  >
                    <img
                      :src="item.pictogram"
                      :alt="item.label"
                    />
                  </div>
                  <span>{{ item.label }}</span>
                </button>
              </n-list-item>
            </n-list>
          </div>
        </div>
      </div>
      <div
        v-if="!isDesktop"
        class="footer-sticky"
      >
        <AnimatedButton
          label="Retour"
          @click="showDropdown = false"
        />
      </div>
    </n-popover>
    <div class="select-service-feedback">
      {{ translationsStore.t("searchbar_error_service") }}
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { NPopover, NList, NListItem } from "naive-ui";
import { useBookingStore } from "../stores/booking";
import { useTranslationsStore } from "../stores/translations";
import { useViewport } from "../composables/useViewport";
import AnimatedButton from "./AnimatedButton.vue";

const isDesktop = useViewport().isDesktop;

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
  modelValue: { type: [String, Number, Object], default: null },
  bookingServicePickerError: Boolean,
  popoverTarget: {
    type: String,
    default: () => "",
  },
});

const emit = defineEmits([
  "update:value",
  "update:modelValue",
  "serviceChanged",
]);
const bookingStore = useBookingStore();
const translationsStore = useTranslationsStore();
const placeholderText = computed(() =>
  translationsStore.t("search_bar_service_picker_group_label")
);

const showDropdown = ref(false);
const selectedLabel = ref("");
const width = ref("912px");
const marginLeft = ref(0);
const dropdownContent = ref(null);
const groups = computed(() =>
  Array.isArray(props.options) ? props.options : props.options?.value || []
);

// keep in sync with parent modelValue
watch(
  [() => props.modelValue, () => bookingStore.service],
  ([newVal, storeService]) => {
    const targetVal = newVal || storeService;
    if (!targetVal || !props.options) {
      selectedLabel.value = "";
      return;
    }

    for (const group of Object.values(props.options)) {
      const found = group.children.find((item) => item.value === targetVal);
      if (found) {
        selectedLabel.value = found.label;
        break;
      }
    }
  },
  { immediate: true }
);

function selectOption(item) {
  selectedLabel.value = item.label;
  showDropdown.value = false;
  // emit like n-select would
  emit("update:value", item.value);
  emit("update:modelValue", item.value);
  console.log("Selected service:", item);
}

const updateMarginAndWidth = () => {
  console.log(isDesktop, "isDesktop");
  if (isDesktop.value) {
    marginLeft.value = "-236px";
    width.value = "912px"; // Default width for larger screens
  } else {
    marginLeft.value = "0px";
    width.value = "100vw"; // Adjust width for smaller screens
  }
};

onMounted(() => {
  updateMarginAndWidth();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateMarginAndWidth);
});

const handleKeyboardNavigation = () => {
  const buttons = dropdownContent.value?.querySelectorAll("button");

  if (buttons && buttons.length > 0) {
    const firstButton = buttons[0];
    const lastButton = buttons[buttons.length - 1];

    lastButton.addEventListener("keydown", (e) => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        firstButton.focus();
      }
    });

    firstButton.addEventListener("keydown", (e) => {
      if (e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        lastButton.focus();
      }
    });
  }

  const escKeyListener = (e) => {
    if (e.key === "Escape") {
      showDropdown.value = false;
      dropdownContent.value?.removeAttribute("tabindex");
      document.querySelector(".select-service .dropdown-btn.active").focus();
    }
  };
  document.addEventListener("keydown", escKeyListener);
};

watch(showDropdown, (newVal) => {
  if (!isDesktop.value) {
    if (newVal) {
      document.body.classList.add("layer-services-open");
    } else {
      document.body.classList.remove("layer-services-open");
    }
  } else {
    if (newVal) {
      nextTick(() => {
        dropdownContent.value?.setAttribute("tabindex", "0");
        dropdownContent.value?.focus();
        handleKeyboardNavigation();
      });
    } else {
      dropdownContent.value?.removeAttribute("tabindex");
      document.querySelector(".select-service .dropdown-btn.active").focus();
    }
  }
});
</script>

<style scoped>
.select-service {
  position: relative;
  height: calc(100% - 2px);
  border: 1px solid rgba(0 0 0 / 10%);
  button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-inline: 1.25rem 1.1875rem;
    min-width: 16.25rem;
    min-height: 3.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.44px;
    text-transform: uppercase;
    text-align: left;
    i {
      font-size: var(--n-arrow-size);
      color: var(--n-arrow-color);
      transition: color 0.3s var(--n-bezier);
      opacity: 0.2;
    }
    svg {
      height: 100%;
      width: 100%;
    }
  }

  :deep(.n-base-selection) {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.44px;
  }
  :deep(.n-base-icon) {
    height: 1rem;
    width: 1rem;
    line-height: 1;
    flex: 0 0 auto;
  }
  @media screen and (max-width: 999px) {
    display: flex;
    align-items: center;
    min-height: 3.875rem;
    margin-top: 1.5rem;
  }
  @media screen and (min-width: 1000px) {
    border: none;
    border-right: 1px solid rgba(0 0 0 / 10%);
    max-width: 16rem;
    :deep(.n-base-selection) {
      width: 16rem;
    }
  }

  :deep(.n-base-suffix) {
    right: 20px;
  }
}

.select-service-feedback {
  color: rgb(var(--brand-black) / 1);
  position: absolute;
  display: none;
  bottom: -30px;
  white-space: nowrap;
  font-size: 0.8125rem;
}

.select-service.has-error {
  margin-bottom: 40px;
  border: 1px solid rgb(var(--brand-black) / 1);
}

.select-service.has-error .select-service-feedback {
  display: block;
}

@media screen and (min-width: 1000px) {
  .select-service.has-error {
    margin-bottom: 0px;
  }

  .select-service.glass.has-error {
    border-color: rgb(var(--brand-white) / 1);
    margin-bottom: 0px;
    height: calc(4rem - 1px);
  }

  .select-service.has-error .select-service-feedback {
    bottom: -1.25rem;
  }

  .select-service.has-error.glass .select-service-feedback {
    bottom: -1.25rem;
  }

  .glass .select-service-feedback {
    color: rgb(var(--brand-white) / 1);
  }

  .select-service .dropdown-btn:focus-visible,
  #dropdownContent:focus-visible,
  #dropdownContent .option-content:focus-visible {
    outline: 1px solid rgb(var(--brand-primary) / 1);
  }
}

:deep(.n-popover) {
  margin-left: -20px !important;
}

.select-service.glass {
  :deep(.n-base-selection) {
    --n-color: transparent;
    --n-color-active: transparent;
    --n-text-color: rgb(var(--brand-white) / 1);
  }
  button {
    min-height: 4rem;
  }
  @media screen and (min-width: 1000px) {
    border-right: 1px solid rgba(255 255 255 / 10%);
    button {
      i {
        opacity: 0.8;
      }
    }
  }
}

:deep(.n-base-select-menu) {
  /* Optional extra safety; core sizing comes from :menu-props above */
  min-width: 0 !important;
  box-sizing: border-box;
  --n-option-text-color-pending: white;
  .n-base-select-option.n-base-select-option--pending {
    color: rgb(var(--brand-white) / 1) !important;
  }
}
.dropdown-btn {
  background: transparent;
  height: 100%;
  border: none;
  cursor: pointer;
}
.dropdown-btn.active .n-base-icon {
  transform: rotate(180deg);
  margin-right: -2px;
}
.option-content {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 20px 16px;
  background-color: #fafafa;
}
.option-content:has(.icon-wrapper) {
  padding: 8px 16px 8px 8px;
}
.icon-wrapper {
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.n-list) {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-inline-start: 0;
}
.dropdown-group-header {
  margin-bottom: 1rem;
  color: var(--color-grey-54, #8a8a8a);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
.option-content {
  cursor: pointer;
}
.option-content:hover,
.option-content:focus,
.option-content:active {
  span {
    text-decoration: underline;
  }
}
.option-content span {
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.44px;
  text-transform: uppercase;
}

@media screen and (min-width: 1000px) {
  .custom-dropdown-inner {
    display: flex;
    gap: 1rem;
    padding: 1.5rem;
  }
  .dropdown-group {
    width: 33.33%;
  }
  .select-service.glass {
    .dropdown-btn {
      color: rgb(var(--brand-white) / 1);
    }
  }
}

.custom-dropdown {
  box-sizing: border-box;
}

/* Mobile version: force fixed top */
.mobile-dropdown {
  /* position: fixed !important; */
  top: 0 !important;
  left: 0 !important;
  /* width: 100vw !important;
  //height: 100svh; or 100vh if you want fullscreen */
  /* overflow: auto; */
  margin: 0 !important;
  z-index: 2000; /* ensure it’s above */
  background: rgb(var(--brand-white) / 1);
}
.footer-sticky {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgb(var(--brand-white) / 1);
  padding: 1.5rem 1.25rem;
  z-index: 10;
  box-shadow: 0 -4px 36px 0 rgba(0 0 0 / 10%);
}
.mobile-dropdown .custom-dropdown-inner {
  padding: 4rem 14px 6.375rem 18px;
}
.mobile-dropdown .close-btn {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
}
.mobile-dropdown .dropdown-group {
  margin-block-start: 1.5rem;
}
.mobile-dropdown .h2 {
  font-family: "neue-haas-grotesk-display", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.42;
  letter-spacing: 0.44px;
  text-transform: uppercase;
}
</style>

<style>
.n-virtual-list {
  --n-option-color-selected: rgb(var(--brand-primary) / 1);
  --n-option-color-active-pending: rgb(var(--brand-primary) / 1);
  --n-option-text-color-active: rgb(var(--brand-white) / 1);
  --n-option-color-active-pending: rgb(var(--brand-primary) / 1);
  --n-option-font-size: 0.75rem;
  margin: 1rem 1.25rem;
}
.n-base-select-menu {
  line-height: 2.5rem;
}
.n-base-select-menu .n-base-select-option {
  text-transform: uppercase;
}
.n-base-select-menu
  .n-base-select-option.n-base-select-option--selected:before {
  background-color: rgb(var(--brand-primary) / 1);
}
</style>
